import { Component, OnInit, inject } from '@angular/core';
import { ResponsiveService } from '@app/services/responsive.service';

@Component({
  selector: 'app-list-standard-quote-page',
  template: `
  @if(responsiveService.isMobileSignal()){
    <app-list-quote-standard-mobile />
  } @else {
    <app-list-quote-standard-desktop />
  }
  `
})
export class ListStandardQuotePageComponent implements OnInit {
  public responsiveService = inject(ResponsiveService);

  ngOnInit(): void {
    this.responsiveService.onListen();
  }
}
